import React from "react";
import { Card } from "react-bootstrap";
import { NavLink } from "react-router-dom";

const Project = () => {
  return (
    <div id="projects" style={{}} className="App bg-dark pb-3">
      <h1 className="text-center py-5 bg-dark" style={{ color: "#ffa500" }}>
        My Project
      </h1>

      <div className="container ">
        <div  className="row ">
          <div className="col-sm-12 col-md-4">
            <Card
              border="primary"
              style={{
                width: "18rem",
                backgroundColor: "#333636",
                border: "none",
              }}
            >
              <Card.Header>
                
                <h4 className="text-white">Apartment Booking</h4>
              </Card.Header>
              <Card.Body>
                <Card.Title className="text-center">
                  <a href="https://remx-apt.web.app/">Remax-Apt</a>
                </Card.Title>
                <br />
                <Card.Text>
                  <h3 className="text-white">Apartment Selling.</h3>
                </Card.Text>
                <Card.Text>
                  <h5 className="text-white">This project developed by React</h5>
                </Card.Text>
                <Card.Text>
                  <a
                    className="ms-1 text-dark"
                    href="https://github.com/RonyMiah/Remax-APT-assinment-12-work-8"
                  >
                   
                    <i className="fab fs-1 text-white fa-github-square"></i>
                  </a>
                  <a
                    className="ps-4 text-white"
                    href="https://github.com/RonyMiah/Remax-APT-server-side-assinment-12-work-8"
                  >
                   
                    <i className="fab text-white fs-1 fa-github-square"></i>
                  </a>
                  <a
                    className="ps-4 text-white"
                    href="https://www.linkedin.com/in/ronymiah/"
                  >
                    
                    <i className="fab text-white  fs-1 fa-linkedin"></i>
                  </a>
                </Card.Text>
                <br />
                <NavLink
                  
                  className="btn text-white border-1 fw-bolder text-black box-btn border border-white"
                  to="/apartment"
                >
                  Projects Details
                </NavLink>
              </Card.Body>
            </Card>
            <br />
          </div>

          <div className="col-sm-12 col-md-4">
            <Card
              border="primary"
              style={{
                width: "18rem",
                backgroundColor: "#333636",
                border: "none",
              }}
            >
              <Card.Header>
                
                <h4  className="text-white">Travel-tourism</h4>
              </Card.Header>
              <Card.Body>
                <Card.Title className="text-center">
                  <a href="https://ph-travel-1e00a.web.app/">PH-Travel</a>
                </Card.Title>
                <br />
                <Card.Text>
                  <h3  className="text-white">Travel Agency .</h3>
                </Card.Text>
                <Card.Text>
                  <h5 className="text-white">This project developed by React</h5>
                </Card.Text>
                <Card.Text>
                  <a
                    className="ms-1 text-white"
                    href="https://github.com/RonyMiah/Travel-tourism-assinment-11-work-9"
                  >
                   
                    <i className="fab text-white fs-1 fa-github-square"></i>
                  </a>
                  <a
                    className="ps-4 text-dark"
                    href="https://github.com/RonyMiah/Travel-tourism-server-side-assinment-11-work-9-"
                  >
                    
                    <i className="fab text-white fs-1 fa-github-square"></i>
                  </a>
                  <a
                    className="ps-4 text-white"
                    href="https://www.linkedin.com/in/ronymiah/"
                  >
                   
                    <i className="fab  fs-1 fa-linkedin"></i>
                  </a>
                </Card.Text>
                <br />
                <NavLink
                  className="btn text-white border-1 fw-bolder text-black box-btn border border-white"
                  to="/travel"
                >
                  Projects Details
                </NavLink>
              </Card.Body>
            </Card>
            <br />
          </div>
          <div className="col-sm-12 col-md-4">
            <Card
              border="primary"
              style={{
                width: "18rem",
                backgroundColor: "#333636",
                border: "none",
              }}
            >
              <Card.Header>
                <h4 className="text-white">MackBook- website</h4>{" "}
              </Card.Header>
              <Card.Body>
                <Card.Title className="text-center">
                  <a href="https://apple-product-69484.web.app/">Apple Product</a>
                </Card.Title>
                <br />
                <Card.Text>
                  <h3 className="text-white">Marketing Details</h3>
                </Card.Text>
                <Card.Text>
                  <h5 className="text-white">This project developed by React</h5>
                </Card.Text>
                <Card.Text>
                  <a
                    className="ms-1 text-white"
                    href="https://github.com/RonyMiah/Apple-Website-Client-Side"
                  >
      
                    <i className="fab fs-1 text-white fa-github-square"></i>
                  </a>
                  <a
                    className="ps-4 text-white"
                    href="https://github.com/RonyMiah/Apple-Website-Server-Side"
                  >
      
                    <i className="fab fs-1 text-white fa-github-square"></i>
                  </a>

                  <a
                    className="ps-4 text-white"
                    href="https://www.linkedin.com/in/ronymiah/"
                  >
                   
                    <i className="fab text-white fs-1 fa-linkedin"></i>
                  </a>
                </Card.Text>
                <br />
                <NavLink
                  className="btn text-white border-1 fw-bolder text-black box-btn border border-white"
                  to="/markting"
                >
                  Projects Details
                </NavLink>
              </Card.Body>
            </Card>
            <br />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Project;
